import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import BrandSetup from './BrandSetup';
import './FirstRunOnboarding.css';

const {FiArrowRight,FiCheck,FiFeather}=FiIcons;

function FirstRunOnboarding({
  stage,
  brand,
  onBegin,
  onSaveBrand,
  onBack,
  onCreatePost
}) {
  if (stage==='setup') {
    return (
      <main className="first-run-setup">
        <div className="first-run-context">
          <span>Welcome to DalePost</span>
          <strong>Set up your first brand</strong>
          <small>We’ll use this foundation to shape every post.</small>
        </div>
        <BrandSetup
          brand={null}
          mode="add"
          onSave={onSaveBrand}
          onCancel={onBack}
        />
      </main>
    );
  }

  if (stage==='complete') {
    return (
      <OnboardingCard
        icon={FiCheck}
        eyebrow="Your studio is ready"
        title={`You're all set, ${brand?.name || 'welcome'}.`}
        text="Your brand foundation is in place. Start with one thought and turn it into your first finished post."
        action="Create your first post"
        onAction={onCreatePost}
      />
    );
  }

  return (
    <OnboardingCard
      icon={FiFeather}
      eyebrow="Welcome to DalePost"
      title="Let’s make your ideas easier to share."
      text="Start by giving DalePost a feel for your brand. It only takes a few thoughtful steps."
      action="Let’s set up your first brand"
      onAction={onBegin}
    />
  );
}

function OnboardingCard({icon,eyebrow,title,text,action,onAction}) {
  return (
    <main className="first-run-page">
      <motion.section
        className="first-run-card"
        initial={{opacity:0,y:18}}
        animate={{opacity:1,y:0}}
        transition={{duration:0.4}}
      >
        <span className="first-run-mark">
          <SafeIcon icon={icon} />
        </span>
        <span className="eyebrow">{eyebrow}</span>
        <h1>{title}</h1>
        <p>{text}</p>
        <button
          type="button"
          className="first-run-action"
          onClick={onAction}
        >
          {action}
          <SafeIcon icon={FiArrowRight} />
        </button>
      </motion.section>
    </main>
  );
}

export default FirstRunOnboarding;